import React, { useMemo } from 'react';
import times from 'lodash/times';
import { Content, SideBar, Wrapper, Title } from '../ReportStyles';
import { StyledCard, Title as CardTitle } from '../Card/Card';
import { StyledLoadingMask, LoadingArchiveButton } from './LoadingViewStyles';
import {
  StyledAlert,
  Icon,
  Content as AlertContent,
  Sidebar as AlertSidebar,
  Title as AlertTitle,
} from '../Alerts/Alert/AlertStyles';

export const LoadingAlert = () => {
  const randomWidths = useMemo(
    () => times(4).map(() => `${((Math.random() / 2 + 0.5) * 300).toFixed(0)}px`),
    [],
  );

  return (
    <StyledAlert>
      <Icon>
        <StyledLoadingMask width="32px" height="32px" />
      </Icon>
      <AlertContent>
        <AlertTitle>
          <StyledLoadingMask width={randomWidths[0]} height="14px" />
        </AlertTitle>
        <StyledLoadingMask width={randomWidths[1]} height="10px" />
        <StyledLoadingMask width={randomWidths[2]} height="10px" />
        <StyledLoadingMask width={randomWidths[3]} height="10px" />
      </AlertContent>
      <AlertSidebar>
        <LoadingArchiveButton>
          <StyledLoadingMask width="14px" height="14px" />
          <StyledLoadingMask width="60px" height="14px" />
        </LoadingArchiveButton>
      </AlertSidebar>
    </StyledAlert>
  );
};

const LoadingView = () => {
  const randomWidths = useMemo(
    () => times(8).map(() => `${((Math.random() / 2 + 0.5) * 300).toFixed(0)}px`),
    [],
  );

  return (
    <>
      <Title>Monitor</Title>
      <Wrapper>
        <Content>
          <StyledCard>
            <CardTitle>Alerts</CardTitle>
            <LoadingAlert />
            <LoadingAlert />
            <LoadingAlert />
            <LoadingAlert />
          </StyledCard>
        </Content>
        <SideBar>
          <StyledCard>
            <CardTitle>
              <StyledLoadingMask width="300px" height="14px" />
              {times(4).map(index => (
                <StyledLoadingMask key={index} width={randomWidths[index]} height="10px" />
              ))}
            </CardTitle>
          </StyledCard>
          <StyledCard>
            <CardTitle>
              <StyledLoadingMask width="200px" height="14px" />
            </CardTitle>
            {times(4).map(index => (
              <StyledLoadingMask key={index} width={randomWidths[index + 4]} height="10px" />
            ))}
          </StyledCard>
        </SideBar>
      </Wrapper>
    </>
  );
};

export default LoadingView;
